export default (api) => {
    return {
        index: options => api.get('subscriptions', options)
    }
}
